import { UniversalCollection, UniversalConfig } from '../interfaces';
import Collection from './Collection/Collection';

/**
 * @class
 * A representation of a universal collection with pagination
 *
 * @param {object} collection - collection model
 * @param {object} sectionConfig - universal api config
 * @param {object} ownProps - collection props
 */
export default class CollectionPagination extends Collection {
  nextToken: string = null;
  totalCount: number = null;

  constructor(collection: UniversalCollection, config: UniversalConfig[], options: string[]) {
    super(collection, config, options);
  }
}
